import { Card, Button, InlineStack, Layout, Pagination, Text, BlockStack } from '@shopify/polaris';
import React, { Suspense, useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
const MemoizedPriceSettings: any = React.lazy(() => import('./SingleValueMapping'));
import { renderSkeletonsValueMapping } from '../../../Settings/Template/Components/skeleton/Skeleton';
import { useTranslation } from "react-i18next";

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
    infor: any;
}

const ValueMappingComponent = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    let pageCount = 10;
    const [activePage, setActivePage] = useState<number>(1);
    // const [savedBackendData, setSavedBackendData] = useState<any>({});
    const [totalCount, setTotalCount] = useState<number>(0);
    const [allAttributes, setAllAttributes] = useState<any>(null);
    const [attributesMarkUp, setAttributesMarkUp] = useState<any>([]);
    const [collapsibles, setCollapsibles] = useState<any>({});
    const [shopifyAttributes, setShopifyAttributes] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(true);
    const [shopifyAttributeLoader, setShopifyAttributesLoader] = useState<boolean>(true);

    const getTotalCountOfAttributes = () => {
        props.di.GET('amazon/product/getAllAttributesofValueMappingCount', {
            "profile_id": props?.location?.state?.id,
            "user_id": props?.redux?.user_id
        }).then(res => {
            if (res?.success) {
                setTotalCount(res?.data);
            }
            else {
                props.error(t(res?.message) ?? t('Some error occured while fetching data'))
            }
        })
    }

    function fillCollapsibleValues(outerAttributes: any) {
        const obj: any = {};
        outerAttributes.map((attribute: any) => {
            obj[attribute.amazon_attribute + "_" + attribute.shopify_attribute] = false;
        })
        setCollapsibles({ ...obj });
    }

    function updateCollapsibles(attribute: string) {
        let tempCollapsibles = { ...collapsibles };
        let keyValue = tempCollapsibles[attribute];
        if (keyValue) {
            tempCollapsibles[attribute] = !tempCollapsibles[attribute];
        }
        else {
            let keys = Object.keys(collapsibles);
            keys.map((key: string) => {
                if (key == attribute) {
                    tempCollapsibles[key] = !keyValue;
                }
                else tempCollapsibles[key] = keyValue;
            })
        }
        setCollapsibles({ ...collapsibles, ...tempCollapsibles });
    }

    const getAllAttributes = (): void => {
        setLoader(true);
        props.di.GET('amazon/product/getAllAttributesofValueMapping', {
            "profile_id": props?.location?.state?.id,
            "user_id": props?.redux?.user_id,
            "activePage": activePage,
            "limit": pageCount
        }).then((res: any) => {
            setLoader(false);
            if (res?.success) {
                setAllAttributes(res?.data?.Attributes);
                fillCollapsibleValues(res?.data?.Attributes);
            }
            else {
                props.error(t(res?.message) ?? t('Some error occured while fetching data'))
            }
        })
    }

    const getShopifyAttributes = () => {
        setShopifyAttributesLoader(true);
        props.di.POST('connector/product/getProductAttributes', { "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] } }).then((response: any) => {
            if (response?.success && response?.data && Object.keys(response?.data).length > 0) {
                let arr: any = [];
                Object.values(response.data).forEach((attribute: any) => {
                    arr = [...arr, ...attribute];
                })
                setShopifyAttributes([...arr]);
            }
            else props.error(t("Error in getting shopify attributes."))
            setShopifyAttributesLoader(false);
        });
    }

    function getShopifyTitle(shopifyAttribute: string): string | undefined {
        if (shopifyAttributes?.length > 0) {
            let shopifyTitle: string = '';
            shopifyAttributes.forEach((attribute: any) => {
                if (attribute.code == shopifyAttribute) shopifyTitle = attribute.title;
            });
            return shopifyTitle;
        }
    }

    useEffect(() => {
        getAllAttributes();
    }, [activePage]);

    useEffect(() => {
        // getSavedDataFromBackend();
        getTotalCountOfAttributes();
        getShopifyAttributes();
        return () => {

        };
    }, []);

    useEffect(() => {
        if (allAttributes?.length > 0 && Object.keys(collapsibles).length > 0) {
            let attributesMarkUp: any = [];
            attributesMarkUp = allAttributes.map((singleAttribute: any) => {
                let shopifyLabel: string | undefined = getShopifyTitle(singleAttribute.shopify_attribute)
                return (
                    <Suspense fallback={<><Layout.AnnotatedSection>{t("Loading Value Mapping data...")}</Layout.AnnotatedSection><br /></>}>
                        <MemoizedPriceSettings
                            amazonAttribute={singleAttribute.amazon_attribute}
                            shopifyAttribute={singleAttribute.shopify_attribute}
                            collapsibles={collapsibles}
                            updateCollapsibles={updateCollapsibles}
                            key={singleAttribute.amazon_attribute + singleAttribute.shopify_attribute}
                            shopifyAttributes={shopifyAttributes}
                            shopifyLabel={shopifyLabel}
                            profileId={props?.location?.state?.id}
                            attributesMappingId={props?.location?.state?.attributesMappingId}
                        // savedBackendData={savedBackendData?.[singleAttribute.amazon_attribute]?.[singleAttribute.shopify_attribute] ?? []}
                        />
                    </Suspense>
                )
            });
            setAttributesMarkUp(attributesMarkUp);
        }
    }, [allAttributes, collapsibles, shopifyAttributes]);

    return (
        <Layout.AnnotatedSection
            id="templateinfo"
            title={t("Value Mapping")}
            description={<Text as='p'>{t("Select values matching to corresponding Amazon attribute values.")} <Button
                target='_blank'
                url='https://support.cedcommerce.com/portal/en/kb/articles/templates-28-3-2025'
                variant="plain">{t("Know more on how to map correct values.")}</Button></Text>}
        >
            <Card roundedAbove='sm'>
                {(loader || shopifyAttributeLoader) ? renderSkeletonsValueMapping() : <BlockStack gap="300">
                    <BlockStack gap="200">
                        {attributesMarkUp}
                    </BlockStack>
                    {!loader && !shopifyAttributeLoader && <InlineStack align='center' gap="300">
                        <Pagination
                            hasNext={activePage < Math.ceil(totalCount / pageCount)}
                            hasPrevious={activePage > 1}
                            onNext={() => {
                                setActivePage((prev) => prev + 1);
                            }}
                            onPrevious={() => {
                                setActivePage((prev) => prev - 1);
                            }}
                            label={`${activePage}/${Math.ceil(totalCount / pageCount)}`}
                        />
                    </InlineStack>}
                </BlockStack>}
            </Card>
        </Layout.AnnotatedSection>
    );
}

export default DI(ValueMappingComponent);
